import { Box, Button, Grid, IconButton, Typography } from "@mui/material"
import { useTranslation } from "react-i18next"
import { icons } from "../../../../../../utils/icons"
import { useStyles } from "./styles"
import { getStatus } from "../../../../../../hooks/status"
import { useContextState } from "../../../../../../hooks/theme"
import { Status } from "../../../../../../utils/enums"
import StatusComponent from "../../../../../../components/status"
import { UserCreator } from "../userCreator"
import { DataFile } from "../dataFile"
import { createRef, useState } from "react"
import { DateModalRange, DateModalRangeRef } from "../../../../../../components/dinamicForm/dateModal"
import { Constants } from "../../../../../../utils/constants"
import { onChange } from "../../../../../../utils/types/generals"
import dayjs from "dayjs"
import { toUnitTimeZone } from "../../../../../../utils/methods/calcDate"
import { FileTabProps } from "./types"
import { SolicitedUsers } from "../solicitedUser"
import { Settings } from "../../../../../../components/settings"
import { ItemMenu } from "../../../../../../components/baseMenu"
import { EditViewNavigate, MenuOptionFileManager } from "../../../../utils/enums/menu"
import { useNavigate, useParams } from "react-router-dom"
import SimpleModal from "../../../../../../components/modal/simpleModal"
import { TableUserSolicited } from "../tableUsersSolicited"
import { LoadingButton } from "@mui/lab"




export const FileDetail = ({ canSubmitEdit, setCanSubmitEdit, handleShowTable, showTable, column, searchUsersSolicited, userFilter, keyFile, canSee, handleEditFile, loadingSave, canDownload, activateOrDesactivate, deleteFile, showOptions, userCreator, backToDetail, inputUser, handleAddUsersSolicited, isLoadingTable, row, deleteUser, isEdit, goBackToList, data, errors, file, setData, setErrors, setFile, status, solictedUser }: FileTabProps) => {

    const { t } = useTranslation()
    const styles = useStyles()
    const { colors } = useContextState()
    const { text, color } = getStatus(status as Status, colors, t)
    const navigate = useNavigate()
    const { id } = useParams()

    const refRange = createRef<DateModalRangeRef>()
    const onChange: onChange = ({ target }) => {
        const { name, value } = target
        setCanSubmitEdit?.(true)
        let body = { ...data }
        body = {
            ...data,
            [name]: value,
        }

        if (['from', 'to'].includes(name)) {
            const from = name == 'from' ? value : data.from
            const to = name == 'to' ? value : data.to

            if (Boolean(to)) {
                let errorMessage = ''
                if (dayjs(to).isBefore(dayjs(from).add(5, 'minute'))) { errorMessage = t('general.validations.minimus5minute') }
                if (dayjs(to).isBefore(dayjs(toUnitTimeZone(new Date(), Constants.defaultTimeZoneObject.value)).add(5, 'minute'))) { errorMessage = t('general.validations.minimusCurrentDay') }
                setErrors(prev => ({
                    ...prev,
                    to: errorMessage
                }))
            }
        }

        setData(prev => ({ ...prev, ...body }))
    }

    const [modal, setModal] = useState<{
        open: boolean
        title: string
        description?: string
        children?: JSX.Element
        removeCancel?: boolean
        confirm: () => void
    }>({
        open: false,
        title: t('filesManager.modal.titles.confirmation'),
        description: '',
        confirm: () => { },
    })

    const menuItems: ItemMenu[] = [
        {
            label: 'Activar',
            value: MenuOptionFileManager.ACTIVATE_FILE,
        },
        {
            label: 'Desactivar',
            value: MenuOptionFileManager.DESACTIVATE_FILE,
        },
        {
            label: 'Editar archivo',
            value: MenuOptionFileManager.EDIT_FILE,
        },
        {
            label: 'Eliminar archivo',
            value: MenuOptionFileManager.DELETE_FILE,
        },
    ]

    const filteredMenuItems: ItemMenu[] = menuItems.filter(item => {
        if (status === Status.ACTIVE && item.value === MenuOptionFileManager.ACTIVATE_FILE) return false;
        if (status === Status.INACTIVE && item.value === MenuOptionFileManager.DESACTIVATE_FILE) return false;
        return true;
    });


    const menuOptions = ({ item }: { item: ItemMenu }) => {
        switch (item.value) {
            case MenuOptionFileManager.ACTIVATE_FILE: {
                setModal(prev => ({
                    ...prev,
                    open: true,
                    description: t('filesManager.modal.description.areYouSureWantActivateThisFile'),
                    confirm: () => {
                        activateOrDesactivate?.();
                        closeModal();
                    }
                }))
                break
            }
            case MenuOptionFileManager.DESACTIVATE_FILE: {
                setModal(prev => ({
                    ...prev,
                    open: true,
                    description: t('filesManager.modal.description.areYouSureWantDesacctivateThisFile'),
                    confirm: () => {
                        activateOrDesactivate?.();
                        closeModal();
                    }
                }))
                break
            }
            case MenuOptionFileManager.EDIT_FILE: {
                navigate(`../edit/${id}`, { state: { option: EditViewNavigate.DETAIL } });
                break
            }
            case MenuOptionFileManager.DELETE_FILE: {
                setModal(prev => ({
                    ...prev,
                    open: true,
                    description: t('filesManager.modal.description.areYouSureWantDeleteThisFileSelected'),
                    confirm: () => {
                        deleteFile?.();
                        closeModal();
                    }
                }))
                break
            }
        }
    }

    const closeModal = () => {
        setModal(prev => ({
            ...prev,
            open: false,
        }))
    }

    const cancelEdition = () => {
        setModal(prev => ({
            ...prev,
            open: true,
            title: t('filesManager.modal.titles.cancelEdition'),
            description: backToDetail ? t('filesManager.modal.description.toBackTheChangesLostDetail') : t('filesManager.modal.description.toBackTheChangesLost'),
            confirm: () => {
                if(!backToDetail){
                    navigate('/dashboard/filesManager/main');
                } else {
                    navigate(`../detail/${id}`);
                }
            }
        }))
    }

    const hadleSubmitEdition = () => {
        setModal(prev => ({
            ...prev,
            open: true,
            title: t('filesManager.modal.titles.confirmation'),
            description: t('filesManager.modal.description.editThisFile'),
            confirm: () => {
                handleEditFile?.()
                closeModal()
                /* if(!backToDetail){
                    navigate('/dashboard/filesManager/main');
                } else {
                    navigate(`../detail/${id}`);
                } */
            }
        }))
    }


    return (
        <Box>
            <Box sx={[styles.mainContainer(solictedUser.length > 2), styles.flex(showTable)]}>

                <Box>
                    <Box sx={styles.headerLeft}>
                        <IconButton onClick={goBackToList}>{icons('arrow-left-fill')}</IconButton>
                        <Typography>{backToDetail ? t('filesManager.buttons.backToDetail'):t('filesManager.buttons.backToListSecond')}</Typography>
                    </Box>

                    <Box sx={styles.conatinerTitle}>
                        <Typography sx={styles.title}>{!isEdit ? t('filesManager.titles.fileDetail') : t('filesManager.titles.fileEdition')}</Typography>

                        <Box sx={styles.containerStatus}>
                            <StatusComponent color={color} msg={text} type="chip" size="medium" />
                            {(!isEdit && showOptions) && <Settings
                                icon="moreVert"
                                iconProps={{
                                    sx: styles.setting
                                }}
                                menu={{
                                    menuItems: filteredMenuItems,
                                    click: (menu) => {
                                        menuOptions({ item: menu })
                                    }
                                }}
                            />}
                        </Box>
                    </Box>
                </Box>

                {showTable && userFilter &&
                    <TableUserSolicited 
                        handleAddUsersSolicited={handleAddUsersSolicited} 
                        isLoadingTable={isLoadingTable} 
                        row={row} 
                        handleShowTable={handleShowTable} 
                        inputUser={inputUser}
                        column={column}
                        searchUsersSolicited={searchUsersSolicited}
                        userFilter={userFilter}
                    />
                }

                {!showTable &&
                    <UserCreator 
                        area={userCreator.area} 
                        department={userCreator.department} 
                        name={userCreator.name} 
                        role={userCreator.role}
                        userType={userCreator.userType}
                    />
                }

                {!showTable &&
                    <Grid container spacing={4} >
                        <Grid item xs={12} sm={12} md={12} lg={6} xl={6} >
                            <DataFile keyFile={keyFile} canSee={canSee} file={file} isEdit={isEdit} setFile={setFile} canDownload={canDownload} />
                        </Grid>

                        <Grid item xs={12} sm={12} md={12} lg={6} xl={6} sx={styles.flex(false)}>
                            <Box sx={styles.flex1}>
                                <Typography variant="title_grey" fontSize={16}>{t('filesManager.titles.displayAndExpiration')}</Typography>

                                <Box sx={styles.containerDate}>
                                    <DateModalRange
                                        mimTimeZone={Constants.defaultTimeZoneObject}
                                        defaultErrors={{ from: errors?.from, to: errors?.to }}
                                        setDate={(payload) => {
                                            onChange({
                                                target: {
                                                    name: payload.target.name,
                                                    value: payload.target.value,
                                                }
                                            })
                                        }}
                                        from={data.from}
                                        to={data.to ?? null}
                                        ref={refRange}
                                        titleFrom="Inicio de visualización"
                                        titleTo="Fin de visualización"
                                        disable={!isEdit}
                                        clear
                                    //minHeight={148}
                                    />
                                </Box>
                            </Box>

                            <SolicitedUsers handleShowTable={handleShowTable} isEdit={isEdit} solictedUser={solictedUser} deleteUser={deleteUser} />
                        </Grid>
                    </Grid>
                }


                <SimpleModal
                    open={!!modal.open}
                    next={modal.confirm}
                    back={closeModal}
                    close={closeModal}
                    description={modal.description}
                    buttonText={t('general.confirm')}
                    cancelText={t('general.cancel')}
                    title={modal.title}
                    loadingButton
                />



            </Box>

            {
                (isEdit && !showTable) &&
                <Box sx={styles.containerButtons}>
                    <Button onClick={cancelEdition}>{t('general.cancel')}</Button>

                    <LoadingButton disabled={!canSubmitEdit && !(file instanceof File)} loading={loadingSave} className="next" variant="contained" onClick={hadleSubmitEdition}>
                        {t('general.save')}
                    </LoadingButton>
                </Box>
            }
        </Box>
    )
}